const config = {
  versao: "1.0.2(Beta) - 21/05/2025 16:28",
  baseURL: "https://path-api-61bc3c4f840d.herokuapp.com/",
  // baseURL: "http://127.0.0.1:3333/",
  baseReportUrl: "https://harpia-report-api-c33b84c0e627.herokuapp.com/api/",
  // baseReportUrl: 'https://localhost:44380/api/',
  //baseURL: 'http://192.168.100.154:3333/',
};

export default config;
